import { Locales } from 'core/user/entities/Locales';

const resolveRegion = (country: string): string => {
  try {
    return new Intl.Locale('und', { region: country }).region ?? Locales.US;
  } catch {
    return Locales.US;
  }
};

const deriveLocaleFromRegion = (region: string): string => {
  const { language, region: maximizedRegion } = new Intl.Locale(`und-${region}`).maximize();

  return maximizedRegion ? `${language}-${maximizedRegion}` : language;
};

export const resolveDisplayLocale = (locale: string | undefined, country: string): string => {
  const region = resolveRegion(country);

  try {
    return locale ? new Intl.Locale(locale, { region }).baseName : deriveLocaleFromRegion(region);
  } catch {
    return deriveLocaleFromRegion(region);
  }
};
